import React from 'react';
import { MedicalProfileFiles } from '../../../../../primary-record-types';
import Text, { TextColor } from '../../../../v2BaseComponents/Text';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('TranscriptLineDisplay', {
    fallbackSpeakerName: 'Speaker {number}',
});

export type TranscriptLineDisplayOwnProps = {
    line: MedicalProfileFiles.TranscriptSection;
    isActive: boolean;
    isPlaying: boolean;
    onSetYPosition?: (yPosition: number) => void;
};

export type TranscriptLineDisplayProps = TranscriptLineDisplayOwnProps;

const TranscriptLineDisplay: React.FC<TranscriptLineDisplayProps> = (props) => {
    const textColor: TextColor = !props.isPlaying || props.isActive ? 'Dark-Text' : 'Gray-Text';
    return (
        <Text variant="body-1" color={textColor} onLayout={(e) => props.onSetYPosition?.(e.nativeEvent.layout.y)}>
            <Text variant="bold-body-1" color={textColor}>
                {`${
                    props.line.speakerName ||
                    intl('fallbackSpeakerName', {
                        number: props.line.speakerIndex + 1,
                    })
                }:`}
            </Text>
            <Text variant="body-1" color={textColor}>{` ${props.line.text}`}</Text>
        </Text>
    );
};

export default React.memo(TranscriptLineDisplay);
